// Agent-specific English strings stay split from the oversized source locale.
export const agentChip = {
  menuLabel: "Agent menu",
  agents: "Agents",
  showAll: "Show all",
  createAgent: "Create new agent",
  newAgent: "New agent",
  creatingAgent: "Creating new agent…",
  namedSettings: "{name} settings",
  newConversation: "New conversation",
  workspaceMenuLabel: "Workspace menu",
  switchAgent: "Switch agent",
  working: "Working…",
  ready: "Ready to chat",
  help: "Help",
  getHelp: "Get support",
  getApps: "Get the apps",
  discord: "Discord community",
  viewChangelog: "View changelog",
};

export const agentScope = {
  label: "Agent",
  allAgents: "All agents",
};

export const pinning = {
  pinToSwitcher: "Pin to switcher",
  unpinFromSwitcher: "Unpin from switcher",
};
